export {}

declare global {
  interface Number {
    humanReadableBytes(): string;
    humanReadableSeconds(): string;
  }
}

Number.prototype.humanReadableBytes = function(this: number): string {
  let bytes: number = parseInt(''+this);
  if (bytes < 1) {
    return '0 bytes';
  }
  const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB'];
  let exp = parseInt(''+Math.floor(Math.log(bytes) / Math.log(1024)));
  if (exp > sizes.length-1) {
    exp = sizes.length-1;
  }
  if (exp > 0) {
    bytes = bytes/Math.pow(1024, exp);
  }
  return bytes.toFixed(1) + ' ' + sizes[exp];
}

Number.prototype.humanReadableSeconds = function(this: number): string {
  let seconds = parseInt(''+this);
  if (seconds < 1) {
    return '0 seconds';
  }
  let minutes = Math.floor(seconds/60.0);
  if (minutes < 2) { // less than 2 minutes)
    return seconds + " seconds";
  } else if (minutes < 120) { // less than 2 hours
    return minutes + " minutes";
  } else if (minutes < 2880) { // less than 2 days
    return Math.floor(minutes/60.0) + " hours";
  } else { // greater than 2 days
    return Math.floor(minutes/60.0/24.0) + " days";
  }      
}


// WEBPACK FOOTER //
// ./src/app/extensions/number.extension.ts